/**
 * assets/alle-koi-collection.js
 * Gedrag van sections/alle-koi-collection.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

  /* Config uit het JSON-eiland #ak-config hierboven. Zie ARCHITECTURE.md sectie 11. */
  var CFG = { productsCount: 0, totalPages: 1, collectionUrl: '', assetBase: '' };
  try {
    var _akEl = document.getElementById('ak-config');
    if (_akEl) CFG = Object.assign(CFG, JSON.parse(_akEl.textContent) || {});
  } catch (_e) {}

(function() {
  'use strict';

  /* ================================================================
     GTAG TRACKING - Alle koi collectie
     ================================================================ */
  function trackEvent(eventName, eventData) {
    if (window.gtag && typeof window.gtag === 'function') {
      window.gtag('event', eventName, eventData);
    }
  }

  /* Track: collectie pagina bekeken */
  trackEvent('alle_koi_view', {
    product_count: CFG.productsCount
  });

  /* ================================================================
     DUAL FILTER (soort + maat)
     ================================================================ */
  var soortPills = document.querySelectorAll('.ak-soort-card[data-filter-type="soort"]');

  /* Mobiel scroll-hint: verberg gradient als gebruiker naar einde scrollt */
  var soortScrollWrap = document.querySelector('.ak-soort-scroll-wrap');
  var soortGrid = document.getElementById('ak-soort-grid');
  if (soortGrid && soortScrollWrap) {
    soortGrid.addEventListener('scroll', function() {
      var atEnd = (this.scrollLeft + this.clientWidth) >= (this.scrollWidth - 20);
      soortScrollWrap.classList.toggle('ak-scrolled-end', atEnd);
    });
  }
  var maatPills = document.querySelectorAll('.ak-filter-pill[data-filter-type="maat"]');
  var cards = document.querySelectorAll('.ak-koi-card');
  var noResults = document.getElementById('ak-no-results');
  var resultsCount = document.getElementById('ak-results-count');
  var resetBtnBottom = document.getElementById('ak-reset-filters');
  var resetBtnTop = document.getElementById('ak-reset-filters-top');

  var activeSoort = 'alle';
  var activeMaat = 'alle';

  function updateResetVisibility() {
    var isFiltered = activeSoort !== 'alle' || activeMaat !== 'alle';
    if (resetBtnTop) {
      resetBtnTop.classList.toggle('ak-filter-reset-visible', isFiltered);
    }
  }

  function applyFilters() {
    var visibleCount = 0;

    cards.forEach(function(card) {
      var soort = card.getAttribute('data-hoofd') || card.getAttribute('data-soort');
      var maat = card.getAttribute('data-maat');

      var soortMatch = (activeSoort === 'alle') || (soort === activeSoort);
      var maatMatch = (activeMaat === 'alle') || (maat === activeMaat);

      if (soortMatch && maatMatch) {
        card.removeAttribute('data-hidden');
        visibleCount++;
      } else {
        card.setAttribute('data-hidden', 'true');
      }
    });

    if (noResults) {
      noResults.style.display = visibleCount === 0 ? 'block' : 'none';
    }

    if (resultsCount) {
      resultsCount.innerHTML = '<strong>' + visibleCount + '</strong> koi gevonden';
    }

    updateResetVisibility();
  }

  function setupPillGroup(pills, type) {
    pills.forEach(function(pill) {
      pill.addEventListener('click', function() {
        var filter = this.getAttribute('data-filter');

        /* Als een actieve niet-alle pill wordt geklikt, reset naar alle */
        if (filter !== 'alle' && this.classList.contains('ak-filter-active')) {
          filter = 'alle';
        }

        pills.forEach(function(p) {
          p.classList.remove('ak-filter-active');
          p.setAttribute('aria-pressed', 'false');
        });

        /* Activeer de juiste pill */
        if (filter === 'alle') {
          pills.forEach(function(p) {
            if (p.getAttribute('data-filter') === 'alle') {
              p.classList.add('ak-filter-active');
              p.setAttribute('aria-pressed', 'true');
            }
          });
        } else {
          this.classList.add('ak-filter-active');
          this.setAttribute('aria-pressed', 'true');
        }

        if (type === 'soort') {
          activeSoort = filter;
        } else {
          activeMaat = filter;
        }

        applyFilters();

        /* Scroll naar eerste zichtbare kaart van deze soort/maat */
        if (filter !== 'alle') {
          setTimeout(function() {
            var selector = type === 'soort'
              ? '.ak-koi-card[data-hoofd="' + CSS.escape(filter) + '"]:not([data-hidden="true"])'
              : '.ak-koi-card[data-maat="' + CSS.escape(filter) + '"]:not([data-hidden="true"])';
            var firstVisible = document.querySelector(selector);
            if (firstVisible) {
              firstVisible.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
              var fallback = document.getElementById('ak-results-count') || document.getElementById('ak-koi-grid');
              if (fallback) fallback.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 100);
        }

        trackEvent('alle_koi_filter_used', {
          filter_type: type,
          filter_value: filter
        });
      });
    });
  }

  if (soortPills.length) setupPillGroup(soortPills, 'soort');
  if (maatPills.length) setupPillGroup(maatPills, 'maat');

  /* Reset knoppen */
  function resetAllFilters() {
    activeSoort = 'alle';
    activeMaat = 'alle';

    soortPills.forEach(function(p) {
      p.classList.remove('ak-filter-active');
      p.setAttribute('aria-pressed', 'false');
      if (p.getAttribute('data-filter') === 'alle') {
        p.classList.add('ak-filter-active');
        p.setAttribute('aria-pressed', 'true');
      }
    });
    maatPills.forEach(function(p) {
      p.classList.remove('ak-filter-active');
      p.setAttribute('aria-pressed', 'false');
      if (p.getAttribute('data-filter') === 'alle') {
        p.classList.add('ak-filter-active');
        p.setAttribute('aria-pressed', 'true');
      }
    });

    applyFilters();
  }

  if (resetBtnBottom) resetBtnBottom.addEventListener('click', resetAllFilters);
  if (resetBtnTop) resetBtnTop.addEventListener('click', resetAllFilters);

  /* ================================================================
     KOI CLICK TRACKING
     ================================================================ */
  var koiLinks = document.querySelectorAll('[data-track-koi]');
  koiLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      trackEvent('alle_koi_koi_click', {
        koi_handle: this.getAttribute('data-track-koi'),
        koi_soort: this.getAttribute('data-track-soort')
      });
    });
  });

  /* ================================================================
     CONTACTFORMULIER - Klaviyo integratie
     Company ID: SNdxLL
     List ID: T9vBjg
     ================================================================ */
  var form = document.getElementById('ak-contact-form');
  var submitBtn = document.getElementById('ak-submit-btn');
  var successMsg = document.getElementById('ak-form-success');

  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var naam = document.getElementById('ak-naam').value.trim();
      var email = document.getElementById('ak-email').value.trim();
      var bericht = document.getElementById('ak-bericht').value.trim();

      if (!naam || !email || !bericht) {
        alert('Vul je naam, e-mailadres en bericht in.');
        return;
      }

      if (email.indexOf('@') === -1 || email.indexOf('.') === -1) {
        alert('Vul een geldig e-mailadres in.');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Bezig met versturen...';

      /* Stap 1: Klaviyo identify */
      var _learnq = window._learnq || [];
      _learnq.push(['identify', {
        '$email': email,
        '$first_name': naam,
        'Bron': 'alle-koi-collectie'
      }]);

      /* Stap 2: Klaviyo track event */
      _learnq.push(['track', 'Alle Koi Collectie Contact', {
        'Bericht': bericht,
        'Bron': 'alle-koi-collectie'
      }]);

      /* Stap 3: Subscribe naar leads lijst */
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SNdxLL', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-02-15'
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Alle Koi Collectie',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    first_name: naam
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: 'T9vBjg'
                }
              }
            }
          }
        })
      }).then(function() {
        form.style.display = 'none';
        successMsg.style.display = 'block';

        trackEvent('alle_koi_contact_submit', {});
      }).catch(function() {
        form.style.display = 'none';
        successMsg.style.display = 'block';
      });
    });
  }
  /* ================================================================
     LAZY LOAD PAGINATION, "Meer laden" knop
     Laadt 20 koi per keer. Bij soort filter: laad ALLES eerst.
     ================================================================ */
  var totalPages = CFG.totalPages;
  var currentPage = 1;
  var allPagesLoaded = (totalPages <= 1);
  var collectionUrl = CFG.collectionUrl;
  var koiGrid = document.getElementById('ak-koi-grid');
  var loadMoreBtn = document.getElementById('ak-load-more');
  var loadMoreText = document.getElementById('ak-load-more-text');
  var loadMoreSpinner = document.getElementById('ak-load-more-spinner');
  var loadMoreIcon = document.getElementById('ak-load-more-icon');
  var progressBar = document.getElementById('ak-progress-bar');
  var loadedCountEl = document.getElementById('ak-loaded-count');
  var paginationWrapper = document.getElementById('ak-pagination');
  var totalProducts = CFG.productsCount;

  function addCardListeners(card) {
    var links = card.querySelectorAll('[data-track-koi]');
    links.forEach(function(link) {
      link.addEventListener('click', function() {
        trackEvent('alle_koi_koi_click', {
          koi_handle: this.getAttribute('data-track-koi'),
          koi_soort: this.getAttribute('data-track-soort')
        });
      });
    });
  }

  function mapHoofdsoort(card) {
    var detailSoort = (card.getAttribute('data-soort') || '').toLowerCase();
    var hoofd = 'Overig';
    if (detailSoort.indexOf('goshiki') > -1) hoofd = 'Goshiki';
    else if (detailSoort.indexOf('kohaku') > -1) hoofd = 'Kohaku';
    else if (detailSoort.indexOf('sanke') > -1) hoofd = 'Sanke';
    else if (detailSoort.indexOf('showa') > -1) hoofd = 'Showa';
    else if (detailSoort.indexOf('utsuri') > -1) hoofd = 'Utsuri';
    else if (detailSoort.indexOf('kikokuryu') > -1) hoofd = 'Kikokuryu';
    else if (detailSoort.indexOf('ochiba') > -1) hoofd = 'Ochiba';
    else if (detailSoort.indexOf('goromo') > -1) hoofd = 'Goromo';
    else if (detailSoort.indexOf('hariwake') > -1) hoofd = 'Hariwake';
    else if (detailSoort.indexOf('kujaku') > -1) hoofd = 'Kujaku';
    else if (detailSoort.indexOf('yamatonishiki') > -1) hoofd = 'Yamatonishiki';
    else if (detailSoort.indexOf('matsukawabake') > -1) hoofd = 'Matsukawabake';
    else if (detailSoort.indexOf('matsuba') > -1) hoofd = 'Matsuba';
    else if (detailSoort.indexOf('asagi') > -1) hoofd = 'Asagi';
    else if (detailSoort.indexOf('shusui') > -1) hoofd = 'Shusui';
    else if (detailSoort.indexOf('ogon') > -1) hoofd = 'Ogon';
    else if (detailSoort.indexOf('benigoi') > -1) hoofd = 'Benigoi';
    else if (detailSoort.indexOf('ginga') > -1) hoofd = 'Ginga';
    else if (detailSoort.indexOf('tancho') > -1) hoofd = 'Tancho';
    card.setAttribute('data-hoofd', hoofd);
  }

  function updatePagination() {
    var loadedCards = document.querySelectorAll('.ak-koi-card').length;
    var pct = Math.min(100, Math.round(loadedCards / totalProducts * 100));
    if (progressBar) progressBar.style.width = pct + '%';
    if (loadedCountEl) loadedCountEl.textContent = loadedCards;
    if (allPagesLoaded || currentPage >= totalPages) {
      /* Alle koi geladen */
      if (loadMoreBtn) loadMoreBtn.style.display = 'none';
      if (paginationWrapper) {
        var doneEl = document.createElement('div');
        doneEl.className = 'ak-all-loaded';
        doneEl.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg> Alle koi geladen';
        var existingDone = paginationWrapper.querySelector('.ak-all-loaded');
        if (!existingDone) paginationWrapper.appendChild(doneEl);
      }
    }
  }

  /* Voeg filter pills toe voor nieuwe hoofdsoorten na pagina-lading */
  var soortAssetMap = {
    'Goshiki': 'goshiki', 'Kohaku': 'kohaku', 'Sanke': 'sanke-doitsu', 'Showa': 'showa',
    'Utsuri': 'utsuri-shiro', 'Kikokuryu': 'kikokuryu', 'Ochiba': 'ochiba', 'Goromo': 'goromo',
    'Hariwake': 'hariwake-doitsu', 'Kujaku': 'kujaku', 'Yamatonishiki': 'yamabuki-ogon',
    'Matsukawabake': 'matsukawabake', 'Matsuba': 'matsuba-kin', 'Asagi': 'asagi',
    'Shusui': 'asagi', 'Ogon': 'yamabuki-ogon', 'Benigoi': 'beniginga',
    'Ginga': 'beniginga', 'Tancho': 'kohaku'
  };
  var assetBase = CFG.assetBase;

  function updateFilterPills() {
    var allCards = document.querySelectorAll('.ak-koi-card');
    var existingSoorten = new Set();
    document.querySelectorAll('.ak-soort-card[data-filter-type="soort"]').forEach(function(el) {
      existingSoorten.add(el.getAttribute('data-filter'));
    });
    var soortGrid = document.getElementById('ak-soort-grid');
    var newAdded = false;

    allCards.forEach(function(card) {
      var h = card.getAttribute('data-hoofd');
      if (h && !existingSoorten.has(h)) {
        existingSoorten.add(h);
        newAdded = true;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ak-soort-card';
        btn.setAttribute('data-filter-type', 'soort');
        btn.setAttribute('data-filter', h);
        btn.setAttribute('aria-pressed', 'false');
        var assetKey = soortAssetMap[h];
        if (assetKey) {
          btn.innerHTML = '<img src="' + assetBase + 'koi-soort-' + assetKey + '.png" alt="' + h + ' koi illustratie" class="ak-soort-card-img"><span class="ak-soort-card-name">' + h + '</span>';
        } else {
          btn.innerHTML = '<div class="ak-soort-card-icon" style="width:96px;height:96px;border-radius:16px;background:var(--vc-light-bg);border:2px solid var(--vc-border);display:flex;align-items:center;justify-content:center;"><svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="var(--vc-text-light)" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></div><span class="ak-soort-card-name">' + h + '</span>';
        }
        /* Click handler voor nieuwe pill */
        btn.addEventListener('click', function() {
          var f = this.getAttribute('data-filter');
          if (f !== 'alle' && this.classList.contains('ak-filter-active')) f = 'alle';
          document.querySelectorAll('.ak-soort-card[data-filter-type="soort"]').forEach(function(p) {
            p.classList.remove('ak-filter-active');
            p.setAttribute('aria-pressed', 'false');
            if (f === 'alle' && p.getAttribute('data-filter') === 'alle') {
              p.classList.add('ak-filter-active');
              p.setAttribute('aria-pressed', 'true');
            }
          });
          if (f !== 'alle') {
            this.classList.add('ak-filter-active');
            this.setAttribute('aria-pressed', 'true');
          }
          activeSoort = f;
          /* Bij klik op soort filter: laad eerst alles */
          if (f !== 'alle' && !allPagesLoaded) {
            loadAllRemaining().then(function() {
              applyFilters();
              setTimeout(function() {
                var fv = document.querySelector('.ak-koi-card[data-hoofd="' + CSS.escape(f) + '"]:not([data-hidden="true"])');
                if (fv) fv.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }, 150);
            });
          } else {
            applyFilters();
            if (f !== 'alle') {
              setTimeout(function() {
                var fv = document.querySelector('.ak-koi-card[data-hoofd="' + CSS.escape(f) + '"]:not([data-hidden="true"])');
                if (fv) fv.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }, 150);
            }
          }
          trackEvent('alle_koi_filter_used', { filter_type: 'soort', filter_value: f });
        });
        if (soortGrid) soortGrid.appendChild(btn);
      }
    });

    if (newAdded) {
      soortPills = document.querySelectorAll('.ak-soort-card[data-filter-type="soort"]');
    }
  }

  function loadPage(page) {
    return fetch(collectionUrl + '?page=' + page + '&section_id=alle-koi-collection')
      .then(function(response) { return response.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newCards = doc.querySelectorAll('.ak-koi-card');
        var noResultsEl = document.getElementById('ak-no-results');
        var fragment = document.createDocumentFragment();

        newCards.forEach(function(card) {
          addCardListeners(card);
          mapHoofdsoort(card);
          /* Fade-in animatie */
          card.style.opacity = '0';
          card.style.transform = 'translateY(16px)';
          fragment.appendChild(card);
        });

        if (noResultsEl) {
          koiGrid.insertBefore(fragment, noResultsEl);
        } else {
          koiGrid.appendChild(fragment);
        }

        /* Animate in */
        requestAnimationFrame(function() {
          var freshCards = koiGrid.querySelectorAll('.ak-koi-card[style*="opacity: 0"]');
          freshCards.forEach(function(c, i) {
            setTimeout(function() {
              c.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
              c.style.opacity = '1';
              c.style.transform = 'translateY(0)';
            }, i * 40);
          });
        });

        /* Update references */
        cards = document.querySelectorAll('.ak-koi-card');
      });
  }

  /* Laad volgende pagina via "Meer laden" knop */
  function loadNextPage() {
    if (currentPage >= totalPages) return Promise.resolve();
    currentPage++;
    return loadPage(currentPage).then(function() {
      updatePagination();
      updateFilterPills();
      /* Re-apply filters als er een actief filter is */
      if (activeSoort !== 'alle' || activeMaat !== 'alle') {
        applyFilters();
      }
    });
  }

  /* Laad ALLE resterende pagina's (bij klik op soort filter) */
  function loadAllRemaining() {
    if (allPagesLoaded) return Promise.resolve();
    if (loadMoreBtn) {
      loadMoreBtn.disabled = true;
      if (loadMoreText) loadMoreText.textContent = 'Alle koi laden…';
      if (loadMoreSpinner) loadMoreSpinner.classList.remove('hidden');
      if (loadMoreIcon) loadMoreIcon.classList.add('hidden');
    }
    var promises = [];
    for (var p = currentPage + 1; p <= totalPages; p++) {
      promises.push(loadPage(p));
    }
    return Promise.all(promises).then(function() {
      currentPage = totalPages;
      allPagesLoaded = true;
      updatePagination();
      updateFilterPills();
      cards = document.querySelectorAll('.ak-koi-card');
      soortPills = document.querySelectorAll('.ak-soort-card[data-filter-type="soort"]');
      if (resultsCount) {
        resultsCount.innerHTML = '<strong>' + cards.length + '</strong> koi gevonden';
      }
    });
  }

  /* Bind "Meer laden" knop */
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function() {
      loadMoreBtn.disabled = true;
      if (loadMoreText) loadMoreText.textContent = 'Laden…';
      if (loadMoreSpinner) loadMoreSpinner.classList.remove('hidden');
      if (loadMoreIcon) loadMoreIcon.classList.add('hidden');

      loadNextPage().then(function() {
        loadMoreBtn.disabled = false;
        if (loadMoreText) loadMoreText.textContent = 'Meer koi laden';
        if (loadMoreSpinner) loadMoreSpinner.classList.add('hidden');
        if (loadMoreIcon) loadMoreIcon.classList.remove('hidden');
      });
    });
  }

  /* ================================================================
     SOORT FILTER: laad eerst alle koi, dan filter + scroll
     ================================================================ */
  soortPills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      var filter = this.getAttribute('data-filter');
      if (filter && filter !== 'alle' && !allPagesLoaded) {
        /* Soort filter geklikt maar nog niet alles geladen → eerst laden */
        loadAllRemaining().then(function() {
          applyFilters();
          setTimeout(function() {
            var firstVisible = document.querySelector('.ak-koi-card[data-hoofd="' + CSS.escape(filter) + '"]:not([data-hidden="true"])');
            if (firstVisible) {
              firstVisible.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 150);
        });
      } else if (filter && filter !== 'alle') {
        setTimeout(function() {
          var firstVisible = document.querySelector('.ak-koi-card[data-hoofd="' + CSS.escape(filter) + '"]:not([data-hidden="true"])');
          if (firstVisible) {
            firstVisible.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 150);
      }
    });
  });

})();
